"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  per_page: 4,
  orderby: "date",
  order: "desc"
};
const wp_query = new WP_Query(wp_query_params);
function ProductsGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="225108" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-l border-t border-transparent">
        {[...Array(4)].map((_, i) => <div key={`skeleton-${i}`} data-index={i} className="border-r border-b border-transparent p-0">
            <div className="aspect-[3/4] w-full animate-pulse bg-secondary/50 rounded-2xl" />
            <div className="p-5 space-y-3">
              <div className="h-5 w-2/3 animate-pulse bg-secondary/50 rounded-md" />
              <div className="h-4 w-1/4 animate-pulse bg-secondary/50 rounded-md" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-muted-foreground font-mono text-sm">
        Unable to load rituals. Please try again later.
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="py-12 text-center text-muted-foreground font-mono text-sm">
        No bars currently available for your ritual.
      </div>;
  }
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-l border-t border-transparent gap-8">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group relative flex flex-col border-r border-b border-transparent bg-background overflow-hidden">
          {}
          <div className="relative aspect-[3/4] w-full overflow-hidden bg-secondary rounded-3xl shadow-sm transition-shadow duration-500 group-hover:shadow-md">
            {}
            <Link to={product.link} className="absolute inset-0 z-10">
              <span className="sr-only">View {product.title}</span>
            </Link>

            {product.featured_image_url ? <>
                {}
                <img src={product.featured_image_url} alt={product.title} className="absolute inset-0 h-full w-full object-cover transition-all duration-1000 ease-in-out group-hover:opacity-0 group-hover:scale-110" loading="lazy" />
                {}
                <img src={product.customFields?.lifestyle_image || product.featured_image_url} alt={`${product.title} lifestyle view`} className="absolute inset-0 h-full w-full object-cover opacity-0 scale-110 transition-all duration-1000 ease-in-out group-hover:scale-100 group-hover:opacity-100" loading="lazy" />
              </> : <div className="absolute inset-0 flex items-center justify-center text-muted-foreground font-mono text-xs uppercase tracking-widest">
                Texture Pending
              </div>}

            {}
            <div className="absolute bottom-4 right-4 translate-y-2 opacity-0 transition-all duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100 z-20">
              <AddToCartButton productId={product.id} className="w-12 h-12" buttonClassName="w-12 h-12 flex items-center justify-center bg-primary text-primary-foreground hover:bg-primary/90 rounded-full font-default text-2xl shadow-xl transition-all" text="+" showQuantity={false} />
            </div>
          </div>

          {}
          <div className="pt-6 pb-2 flex flex-col gap-1 relative z-10 bg-background">
            <Link to={product.link} className="inline-block w-fit hover:opacity-60 transition-opacity">
              <h3 className="text-foreground font-default font-semibold text-lg tracking-normal normal-case truncate">
                {product.title}
              </h3>
            </Link>
            <p className="font-default text-sm text-muted-foreground/80 tracking-wide">
              ${product.price?.toFixed(2)}
            </p>
          </div>
        </div>)}
    </div>;
}
export default function FeaturedStatementPieces() {
  return <section id="the-curated-collection" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-6 md:px-12 mb-16 flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div className="max-w-2xl">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground tracking-tight normal-case mb-6">
            The Curated Collection
          </h2>
          <p className="text-muted-foreground font-default text-base md:text-lg max-w-md leading-relaxed opacity-90">
            Artisan bars handcrafted for the sensory seeker. Each piece is cured for six weeks to ensure a dense, creamy lather that transforms your daily ritual.
          </p>
        </div>
        <Link to="#" className="inline-flex items-center justify-center border-b border-primary pb-1 text-sm font-default font-semibold text-primary uppercase tracking-widest hover:text-muted-foreground hover:border-muted-foreground transition-all w-fit">
          View All Rituals
        </Link>
      </div>

      <div className="container mx-auto px-6 md:px-12">
        <EcommerceProductsProvider wp_query={{
        per_page: 4,
        orderby: "date",
        order: "desc"
      }}>
          <ProductsGridConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}